import { List, Modal, Checkbox, Switch } from 'antd';
import get from 'lodash/get';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withCreateReferralAddReferral } from 'src/_shared/api/components/contacts/';
import { withJobById } from 'src/_shared/api/components/jobs/';
import { withGetTieredBonus } from 'src/_shared/api/components/tiered-bonuses';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import { ToggleOpenClosedNew } from 'src/_shared/components/toggleOpenClosedNew/';
import {
	compose,
	getSetErrorImageURL,
	ml,
	searchOpenSearchNetwork,
} from 'src/_shared/services/utils.js';
import fileIcon from '../../_shared/assets/erin_lightgray.png';
import { SearchComponent } from '../../_shared/components/search';
import ReferralModalWrapper from './ReferralModalWrapper.jsx';


class AddReferralJobModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			company: get(props, 'currentUser.company'),
			autoCompleteResult: [],
			isSubmitting: false,
			newContact: true,
			error: false,
			errorImage: props.currentUser?.company?.errorImage?.key ?? false,
			errorImageURL: null,
			jobs: props.jobs,
			loaded: true,
			loading: true,
			searchQuery: '',
			theme: get(props, 'theme', {}),
			filterOpenStatus: true,
			text: 'Open Jobs',
			whiteLabel: props.currentUser?.company?.whiteLabel ?? false,
		};
	}

	async componentDidMount() {
		try {
			if (this.props.matchFound) {
				this.setState({ autoCompleteResult: [this.props.matchFound] });
			}

			if (this.props.contact) {
				this.setState({ autoCompleteResult: [this.props.contact] });
			}

			await this.setQueryToState(get(this.state, 'searchQuery', ''));
			
			if (this.state?.errorImage?.key) {
				const errorImageURL = await getSetErrorImageURL(
					this.state.errorImage.key
				);

				if (errorImageURL) {
					this.setState({ errorImageURL });
				}
			}
		} catch (error) {
			console.error('Error in componentDidMount:', error);
			this.setState({ 
				loading: false, 
				error: true,
				searchedJobs: []
			});
		}
	}

	componentWillUnmount() {
		if (this._loadTimeout) {
			clearTimeout(this._loadTimeout);
			this._loadTimeout = null;
		}
		if (this._searchTimeout) {
			clearTimeout(this._searchTimeout);
			this._searchTimeout = null;
		}
		this._currentRequestId = null;
	}

	setQueryToState = async (searchQuery = '', overrideFilterOpenStatus = null) => {
		try {
			const requestId = Date.now();
			this._currentRequestId = requestId;
			
			this.setState({ loading: true });

			const {
				company,
				filteredDepartments = [],
				filteredDistance = 0,
				filterOpenStatus = true,
			} = this.state;

			const currentFilterOpenStatus = overrideFilterOpenStatus !== null ? overrideFilterOpenStatus : filterOpenStatus;
			const openStatus = currentFilterOpenStatus ? 'open' : 'closed';
			const parameters = {
				query: searchQuery,
				size: 300,
				role: get(this.props, 'currentUser.role'),
				currentUser: get(this.props, 'currentUser.id'),
				filters: {
					companies: [get(company, 'id')],
					departments: filteredDepartments,
					distance: filteredDistance,
					status: openStatus,
				},
			};
			
			const response = await searchOpenSearchNetwork(parameters, 'erin-jobs');
			
			if (this._currentRequestId === requestId) {
				if (response?.data) {
					const searchedJobs = response?.data || [];
					this.setState({ loading: false, searchedJobs: searchedJobs, error: false });
				} else {
					this.setState({ 
						loading: false, 
						searchedJobs: [],
						error: false
					});
				}
			}
		} catch (error) {
			console.error('Error in setQueryToState:', error);
			if (this._currentRequestId) {
				this.setState({ 
					loading: false, 
					error: true,
					searchedJobs: []
				});
			}
		}
	};

	handleSetQueryToState = async () => {
		try {
			await this.setQueryToState(this.state.searchQuery);
		} catch (error) {
			console.error('Error in handleSetQueryToState:', error);
			this.setState({ 
				loading: false, 
				error: true 
			});
		}
	}

	debouncedSearch = (searchQuery) => {
		if (this._searchTimeout) {
			clearTimeout(this._searchTimeout);
		}
		
		this.setState({ searchQuery });
		
		this._searchTimeout = setTimeout(async () => {
			try {
				await this.setQueryToState(searchQuery);
			} catch (error) {
				console.error('Error in debouncedSearch:', error);
			}
		}, 500);
	}

	handleError = () => {
		this.setState({ error: true });
	};

	render() {
		const {
			data,
			visible,
			handleCancel,
			selectJobCreateReferralText,
			searchJobsText,
			referralInformationText,
			createReferralForText,
			positiontext,
			selectEmployeeText,
			enterReferralInformationText,
			firstNameText,
			lastNameText,
			emailText,
			clickHereText,
			attachResumeText,
			noteText,
			referralAutomaticallyAcceptedText,
			submitReferralText,
			bonusText,
			client,
		} = this.props;
		const {
			company,
			isSubmitting,
			searchQuery,
			theme,
			filterOpenStatus,
			searchedJobs = [],
		} = this.state;

		if (this.state.nextToken !== null && !this.state.loaded) {
			return (
				<div style={{ height: 589 }}>
					<Spinner translateY="25%" company={company} />
				</div>
			);
		}

		if (this.state.nextToken === null && !this.state.loaded) {
			if (!this._loadTimeout) {
				this._loadTimeout = setTimeout(() => {
					this.setState({ loaded: true });
					this._loadTimeout = null;
				}, 1000);
			}
		}

		return (
			<Modal
				centered
				open={visible}
				wrapClassName="ant-modal-lg"
				grid={{ column: 5 }}
				footer={null}
				title={`${selectJobCreateReferralText}`}
				onCancel={handleCancel}
			>
				{isSubmitting ? (
					<div />
				) : (
					<div className="select-job-filter">
						<div style={{display: 'flex', gap: 12}}>
							<span style={{fontWeight: filterOpenStatus ? 900 : 600}}>Open</span>
							<Switch
								checked={!filterOpenStatus}
								onChange={async (checked) => {
									const newFilterOpenStatus = !checked;
									this.setState({filterOpenStatus: newFilterOpenStatus, loading: true});
									await this.setQueryToState(this.state.searchQuery, newFilterOpenStatus);
								}}
							/>
							<span style={{fontWeight: filterOpenStatus ? 600 : 900}}>Closed</span>
						</div>
						<SearchComponent
							searchQuery={searchQuery}
							setQueryToState={this.debouncedSearch}
							placeholder={searchJobsText}
						/>
					</div>
				)}
				{this.state.loaded && !this.state.loading ? (
					<>
						{searchedJobs && searchedJobs.length > 0 ? (
							<List
								className="select-job-card-wrap"
								grid={{ gutter: 20, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }}
								pagination={{ pageSize: 12, showSizeChanger: false }}
								dataSource={searchedJobs}
								renderItem={(job) => {
									return  job?.id && (
										<List.Item>
											<ReferralModalWrapper
												allMultiLingualData={this.props.allMultiLingualData}
												toggleLoading={this.props.toggleLoading}
												history={this.props.history}
												client={client}
												currentUser={this.props.currentUser}
												handleCancel={handleCancel}
												updateReferrals={this.props.updateReferrals}
												theme={theme}
												data={data}
												jobData={job}
												job={job}
												jobId={get(job, 'id')}
												referrals={job.referrals}
												referralInformationText={referralInformationText}
												createReferralForText={createReferralForText}
												positiontext={positiontext}
												selectEmployeeText={selectEmployeeText}
												enterReferralInformationText={
													enterReferralInformationText
												}
												firstNameText={firstNameText}
												lastNameText={lastNameText}
												emailText={emailText}
												clickHereText={clickHereText}
												attachResumeText={attachResumeText}
												noteText={noteText}
												referralAutomaticallyAcceptedText={
													referralAutomaticallyAcceptedText
												}
												submitReferralText={submitReferralText}
												bonusText={bonusText}
												referralLogs={this.props.referralLogs}
												currentTieredBonus={this.props.currentTieredBonus}
												currentReferralCount={this.props.currentReferralCount}
												contacts={this.props.contacts}
												onCreateContact={this.props.ImportedCreateContact}
												onCreateReferral={this.props.onCreateReferral}
												onUpdateContact={this.props.onUpdateContact}
											/>
										</List.Item>
									)
								}}
							/>
						) : (!searchedJobs?.length &&
						  !this.state.loading && this.state.loaded ? (
							<div className="no-content">
								{this.state.whiteLabel ? (
									<img
										src={this.state?.errorImageURL ?? fileIcon}
										alt="error image"
										className="no-content-icon"
									/>
								) : (
									<img
										alt="erin-logo"
										className="no-content-icon"
										src={fileIcon}
									/>
								)}

								<p className="no-content-text">No jobs found</p>
							</div>
						) : (
							<div style={{ height: 589 }}>
								<Spinner translateY="25%" company={company} />
							</div>
						))}
					</>
				) : (
					<div style={{ height: 589 }}>
						<Spinner translateY="25%" company={company} />
					</div>
				)}
			</Modal>
		);
	}
}

const mapStateToProperties = (state) => {
	const { currentUser } = state.user;
	return {
		currentUser,
	};
};

export default compose(
	connect(mapStateToProperties),
	withCreateReferralAddReferral,
	withGetTieredBonus,
	withJobById,
	withApollo,
	withRouter
)(AddReferralJobModal);
